export const centsToDollars = (cents: number): number => cents / 100;
export const dollarsToCents = (dollars: number): number => dollars * 100;
export const centsToDollarsStr = (cents: number): string => {
  return `$${(cents / 100).toFixed(2)}`;
};

/**
 * Adds commas to a number for better readability.
 */
export const formatNumberWithCommas = (number: number): string => {
  return new Intl.NumberFormat('en-US').format(number);
};

export function inDollars(inCents: number): string {
  return (inCents / 100).toFixed(2);
}
